import type {ComponentPropsWithoutRef} from 'react';
import {cn} from '@chekinapp/ui';

function VelaTray({className, ...props}: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn(
        'mt-auto flex-none rounded-[18px] bg-[var(--assistant-tip-icon-bg)] px-3.5 py-4',
        "[[data-fit~='2']_&]:p-3 [[data-fit~='5']_&]:p-2",
        className,
      )}
      {...props}
    />
  );
}

export {VelaTray};
